module.exports = __webpack_public_path__ + "media/images/sale_crm/module_cust-63ff676dd081dfc40401f662111daa9b.svg";